var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgPersona = function SvgPersona(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#persona_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffaf00",
    stroke: "red",
    d: "M5.969.5h22.143c1.565 0 2.948.69 4.004 1.746l5.638 5.638c1.045 1.045 1.746 2.44 1.746 4.004V34.03a5.47 5.47 0 0 1-5.469 5.469H11.888c-1.566 0-2.941-.683-4.004-1.746l-5.638-5.638C1.194 31.064.5 29.677.5 28.112V5.97A5.47 5.47 0 0 1 5.969.5Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M27.188 5.918H6.89a.97.97 0 0 0-.971.972v3.564c0 .536.435.971.971.971h15.35l-10.402 6.5v-4.437a.555.555 0 0 0-.85-.47l-4.287 2.679a1.67 1.67 0 0 0-.783 1.412v10.08c0 .536.435.97.971.97h3.977a.97.97 0 0 0 .972-.97V24.72l15.539-9.71c.487-.304.783-.838.783-1.413V6.89a.97.97 0 0 0-.972-.97m-1.896 19.912a.912.912 0 0 1 0-1.823c.382 0 .71.237.845.571l.842-.093a1.743 1.743 0 1 0 0 .867l-.842-.093a.91.91 0 0 1-.845.571"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M25.292 22.497a2.427 2.427 0 0 1 2.423 2.424 2.426 2.426 0 0 1-2.423 2.423 2.426 2.426 0 0 1-2.424-2.424 2.426 2.426 0 0 1 2.424-2.423m0-.833a3.256 3.256 0 1 0 0 6.513 3.256 3.256 0 0 0 0-6.513"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "persona_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))))));
};
export default SvgPersona;